// extracted by mini-css-extract-plugin
export default {"container":"IkDCa","content":"_3T224"};